<template>
  <!--TODO: Remove wb-colors after update 6.0-->
  <div class="owc-footer-newsletter" :data-theme="brand">
    <div class="wb-grid-row">
      <div
        class="owc-footer-newsletter__container wb-grid-col-mq1-10 wb-grid-col-offset-mq1-1 wb-grid-col-offset-mq3-0 wb-grid-col-mq3-12 wb-grid-col-mq5-8"
      >
        <h5 class="owc-footer-newsletter__title">
          {{ titleLabel }}
        </h5>
        <p class="owc-footer-newsletter__description">
          {{ descriptionLabel }}
        </p>
      </div>
      <div
        class="owc-footer-newsletter__container wb-grid-col-mq1-10 wb-grid-col-offset-mq1-1 wb-grid-col-offset-mq3-0 wb-grid-col-mq3-12 wb-grid-col-offset-mq5-1 wb-grid-col-mq5-3"
      >
        <div class="owc-footer-newsletter__button">
          <a
            :href="actionURL"
            class="wb-button wb-button--primary wb-button--large"
            @click="customTrackingTrigger"
            data-track="false"
          >
            {{ submitLabel }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import ComponentInitializeDispatcher from '@owc-utils/Mixins/ComponentInitializeDispatcher';
import { componentMode } from './Footer.config';
import { NewsletterData, NewsletterMethods, NewsletterComputed, NewsletterProps } from './Newsletter';
import { setBrandTheme } from '@owc-utils/Theming/theming';
/**
 * `Newsletter Footer` - Newsletter for OneWeb - Newsletter Footer contains a button link which redirects the user to a given url, mostly to a newsletter signup form.
 */

export default ComponentInitializeDispatcher.extend<
  NewsletterData,
  NewsletterMethods,
  NewsletterComputed,
  NewsletterProps
>({
  name: 'owc-newsletter',
  props: {
    newsletter: {
      type: Object,
    },
  },
  computed: {
    isEdit: function(): boolean {
      return componentMode.isEditMode;
    },
    titleLabel: function(): string {
      return this.isEdit ? this.componentData?.titleLabel : this.newsletter?.titleLabel;
    },
    submitLabel: function(): string {
      return this.isEdit ? this.componentData?.submitLabel : this.newsletter?.submitLabel;
    },
    descriptionLabel: function(): string {
      return this.isEdit ? this.componentData?.descriptionLabel : this.newsletter?.descriptionLabel;
    },
    actionURL: function(): string {
      return this.isEdit ? this.componentData?.actionURL : this.newsletter?.actionURL;
    },
    brand() {
      return setBrandTheme();
    },
  },
  methods: {
    customTrackingTrigger() {
      this.handleCustomTracking(this.$el, 'newsletter', 'link', 'click', 'navigation', this.actionURL);
    },
  },
});
</script>

<style lang="scss">
@import '@owc-styles/utils/rtl-utils';
@import '@owc-styles/utils/theming';

$newsletterModuleName: 'owc-footer-newsletter';

/*
* Due to the [ltr] attribute used on the WB grid, we had to increase
* the specificitty of the classes used by the newsletter.
*
* TODO: There's a high chance that some of the components that use wb grid
* classes might be affected as well.
*/
.#{$newsletterModuleName} {
  width: 100%;
  padding: var(--wb-spacing-s) 0;

  border: solid 1px var(--wb-grey-40);
  border-radius: 2px;

  .#{$newsletterModuleName} {
    &__container {
      @include breakpoint-between(mq3, mq5) {
        &:first-child,
        &:last-of-type {
          margin: 0 var(--wb-spacing-s);
        }
      }
      @include breakpoint-from(mq5) {
        &:first-child {
          margin: 0;
        }
        // centering email and subscribe button vertically
        &:last-of-type {
          display: flex;
          align-items: center;
        }
      }
    }
    // reseting wb grid from mq5 (currently there is no reset class for this)
    &__button,
    &__email {
      @include breakpoint-from(mq3) {
        width: auto;
        padding: 0;
      }
    }
    &__title {
      @include wb-type-heading-xs;

      margin-bottom: var(--wb-spacing-xxs);

      @include breakpoint-from(mq5) {
        margin-left: var(--wb-spacing-s);
      }
    }
    &__description {
      @include wb-type-copy-secondary;

      margin-bottom: var(--wb-spacing-m);

      color: var(--wb-grey-60);

      @include breakpoint-from(mq5) {
        margin-bottom: 0;
        margin-left: var(--wb-spacing-s);
      }
    }
    &__email {
      margin-bottom: var(--wb-spacing-xs);

      @include breakpoint-from(mq3) {
        flex-grow: 1;

        margin-top: 0;
        margin-right: var(--wb-spacing-xs);
        margin-bottom: 0;
      }
    }
    &__button {
      width: 100%;

      @include breakpoint-from(mq3) {
        margin-top: 0;
      }
      @include breakpoint-from(mq5) {
        margin-right: var(--wb-spacing-s);
      }

      .wb-button {
        width: 100%;
      }
    }
  }
}

@include rtl-rule('.owc-footer-newsletter', false) {
  &__container {
    text-align: initial;
  }
  &__title {
    @include breakpoint-from(mq5) {
      margin-right: var(--wb-spacing-s);
      margin-left: 0;
    }
  }
  &__description {
    @include breakpoint-from(mq5) {
      margin-right: var(--wb-spacing-s);
      margin-left: 0;
    }
  }
  &__button {
    @include breakpoint-from(mq5) {
      margin-right: 0;
      margin-left: var(--wb-spacing-s);
    }
  }
}
</style>
